import React from "react";

import useUser from "@src/features/app/hooks/useUser";
import AskOpusButton from "@src/features/assistantChat/AskOpusButton";
import { AddPaymentMethodBanner } from "@src/features/app/AddPaymentMethodBanner";
import { AddPhoneNumberBanner } from "@src/features/app/AddPhoneNumberBanner";
import JumpToBar from "@src/features/app/top-nav/JumpToBar";
import HelpButton from "@src/features/app/top-nav/HelpButton";
import { NotificationBell } from "@src/features/app/top-nav/NotificationBell";
import TopNavProfileMenu from "@src/features/app/top-nav/TopNavProfileMenu";
import { UserType } from "@src/types.generated";

const TopNav: React.FC = () => {
  const { user } = useUser();
  const isTrainee = !user || user?.userType === UserType.Employee;

  return (
    <>
      <header className="relative flex h-12 shrink-0 items-center gap-3 px-1 md:px-2">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <div
            id="top-nav-leading"
            className="flex shrink-0 items-center empty:hidden"
          />
          {!isTrainee ? <JumpToBar /> : null}
        </div>
        <div className="flex shrink-0 items-center gap-1.5 [&_button]:h-8 [&_button]:min-h-8">
          {!isTrainee ? <NotificationBell dropdownSide="bottom" /> : null}
          <TopNavProfileMenu variant={isTrainee ? "trainee" : "admin"} />
          {!isTrainee ? <HelpButton /> : null}
          <AskOpusButton />
        </div>
      </header>
      <AddPhoneNumberBanner />
      <AddPaymentMethodBanner />
    </>
  );
};

export default TopNav;
